export const businessHours = {
  // Behind the wheel lessons hours
  lessons: {
    weekdays: {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '17:00',
      display: '7am–5pm'
    },
    saturday: {
      days: ['Saturday'],
      opens: '07:00',
      closes: '14:00',
      display: '7am–2pm'
    }
  },

  // Office/phone hours
  office: {
    weekdays: {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '10:00',
      closes: '15:00',
      display: '10:00am–3:00pm'
    },
    weekend: {
      days: ['Saturday', 'Sunday'],
      display: 'Closed'
    }
  }
}

// Convert to Schema.org OpeningHoursSpecification format for JSON-LD
export const getSchemaHours = (hoursType = 'office') => {
  const hours = businessHours[hoursType]
  const specifications = []

  // Add weekday hours
  if (hours.weekdays) {
    specifications.push({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: hours.weekdays.days,
      opens: hours.weekdays.opens,
      closes: hours.weekdays.closes
    })
  }

  // Add Saturday hours (for lessons)
  if (hours.saturday) {
    specifications.push({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: hours.saturday.days,
      opens: hours.saturday.opens,
      closes: hours.saturday.closes
    })
  }

  // Note: We don't add closed days to Schema.org as they're implied when not specified

  return specifications
}

export const phoneNumber = '+1-612-623-4142'

export const years = 45
